import $ from 'jquery';
window.jQuery = $;

window.pw = (window.pw) || {};

window.pw = $.extend(window.pw, {
    doc: function () {
        this.m = this.m || {};
        if (arguments[0] && arguments[1]) {
            var n = arguments[0];
            this.m[arguments[0]] = {
                version: arguments[1],
                info: (arguments[2] && arguments[2].length) ? arguments[2].join("; ") : ' - '
            }
        }
        if(arguments.length === 0) {
            console.table(this.m);
        }

    }
});

console.debug = function () {
    // todo Debugowanie tylko w trybie developerskim.
    for (var i = 0; i < arguments.length; i++) {
        console.log('%c' + arguments[0], 'color: green;');
    }
};


(function ($, pw) {

    "use strict";

    pw.doc('Core', '1.4.190226', ['trigger: ajax:postLoad']);

    var flashMessengerContainer = $('#flashMessenger');

    /**
     *
     * @param data
     * @param wrapper
     * @param useMethod  set|append|prepend
     * @param filterFunction  undefined| function(){}
     */
    pw.ajaxContent = function (data, wrapper, useMethod, filterFunction ) {

        var uiData = $('<html />').html(data),
            htmlData = uiData.find('#ajaxContent').html(),
            dataPre = uiData.find('#ajaxPre').html(),
            modals = uiData.find('.modal'),
            flashMessenger = uiData.find('#ajaxFlashMessenger').html(),
            method = useMethod || 'set'
        ;

        // if(!filter) filter = function(html) { return html }

        if (modals.length) {
            // Remove Exists modals
            modals.each(function () {
                var id = $(this).attr('id');
                if (id) {
                    console.debug('Modal #' + id + ' will be replaced.');
                    $('body').find('#' + id).remove();
                }
            });
        }

        console.log('filterFunction', filterFunction, useMethod);

        if(typeof filterFunction === 'function') {
            htmlData = filterFunction.apply(wrapper, [htmlData]);
        }


        if (wrapper) {

            var htmlDataTest = $('<div>').append(htmlData);
            var replacedContainer = htmlDataTest.find('[data-ajax-replace-container]');

            if(replacedContainer.length) {
                replacedContainer.each(function () {
                    var container = $(this);

                    container.find('[data-ajax-replace]').each(function () {

                        var el = $(this),
                            elSource = wrapper.find('[data-ajax-replace="'+ el.attr('data-ajax-replace') +'"]')
                        ;
                        elSource.replaceWith(el);
                    })
                }).remove();
                htmlData = htmlDataTest.html();
                // console.log('htmlData',htmlData);
            }


            switch (method) {
                case 'append' :
                    wrapper.append(htmlData);
                    break;
                case 'prepend' :
                    wrapper.prepend(htmlData);
                    break;
                case 'replace' :
                    $(htmlData).find('[data-ajax-replace]').each(function () {
                        var el = $(this),
                            elSource = wrapper.find('[data-ajax-replace="'+ el.attr('data-ajax-replace') +'"]')
                        ;
                        elSource.replaceWith(el);
                    });
                    break;
                default:
                    wrapper.html(htmlData);

            }
            wrapper.removeClass('loading');
        }

        if (dataPre) {
            $('body').append(dataPre);
            $('.pw-pre:last').addClass('ajax');
        }

        if ($.material) {
            $.material.init();
        }

        if (flashMessenger) {
            flashMessengerContainer
                .append(flashMessenger)
                .trigger('flash:message');
        }

        if (wrapper) {
            wrapper.trigger('pw.segment.postLoad', [wrapper]);
            wrapper.trigger('ajax:postLoad', [wrapper]);
        }
    };

    pw.ajaxSections = function (data) {

        var uiData = $('<html>').html(data),
            sections = uiData.find('#ajaxContent [data-section]'),
            dataPre = uiData.find('#ajaxPre').html(),
            modals = uiData.find('.modal'),
            flashMessenger = uiData.find('#ajaxFlashMessenger').html()
        ;

        sections.each(function () {
            var e = $(this),
                sectionId = e.attr('data-section');
            console.debug(sectionId);
            if(sectionId) {
                $('[data-section="'+ sectionId +'"]').html(e.html()).removeClass('loading');
            }

        });

        if (dataPre) {
            $('body').append(dataPre);
            $('.pw-pre:last').addClass('ajax');
        }

        if ($.material) {
            $.material.init();
        }

        if (flashMessenger) {
            flashMessengerContainer
                .append(flashMessenger)
                .trigger('flash:message');
        }

    };

    /**
     *
     * @param dom
     * @param notRemoveDataPrefix
     * @returns {{}}
     */
    pw.getDataAttributes = function (dom, notRemoveDataPrefix) {
        var attributes = {};
        $.each(dom.get(0).attributes, function (i, attrib) {
            if (attrib.name.match("^data-")) {
                if (notRemoveDataPrefix !== undefined && notRemoveDataPrefix) {
                    attributes[attrib.name] = attrib.value;
                } else {
                    attributes[attrib.name.slice(5)] = attrib.value;
                }

            }
        });
        return attributes;
    };

    pw.flashMessenger = function (flashMessenger) {
        if (flashMessenger) {
            flashMessengerContainer
                .append(flashMessenger)
                .trigger('flash:message');
        }
    };

    var oldAjax = $.ajax;

    $.ajax = function (opts) {
        return $.Deferred(function () {

            var _def = this;

            oldAjax
                .call(this, opts)
                .done(function (res) {

                    if (res && res.__flashMessenger__) {
                        pw.flashMessenger(res.__flashMessenger__);
                        // delete res.__flashMessenger__;
                    }

                    _def.resolve(res);
                    // else _def.reject("timeout");
                })
                .fail(function () {
                    _def.reject();
                });
        });
    };


    $.fn.serializeObject = function(){

        var self = this,
            json = {},
            push_counters = {},
            patterns = {
                "validate": /^[a-zA-Z][a-zA-Z0-9_]*(?:\[(?:\d*|[a-zA-Z0-9_]+)\])*$/,
                "key":      /[a-zA-Z0-9_]+|(?=\[\])/g,
                "push":     /^$/,
                "fixed":    /^\d+$/,
                "named":    /^[a-zA-Z0-9_]+$/
            };


        this.build = function(base, key, value){
            base[key] = value;
            return base;
        };

        this.push_counter = function(key){
            if(push_counters[key] === undefined){
                push_counters[key] = 0;
            }
            return push_counters[key]++;
        };

        $.each($(this).serializeArray(), function(){

            // skip invalid keys
            if(!patterns.validate.test(this.name)){
                return;
            }

            var k,
                keys = this.name.match(patterns.key),
                merge = this.value,
                reverse_key = this.name;

            while((k = keys.pop()) !== undefined){

                // adjust reverse_key
                reverse_key = reverse_key.replace(new RegExp("\\[" + k + "\\]$"), '');

                // push
                if(k.match(patterns.push)){
                    merge = self.build([], self.push_counter(reverse_key), merge);
                }

                // fixed
                else if(k.match(patterns.fixed)){
                    merge = self.build([], k, merge);
                }

                // named
                else if(k.match(patterns.named)){
                    merge = self.build({}, k, merge);
                }
            }

            json = $.extend(true, json, merge);
        });

        return json;
    };


})(window.jQuery, window.pw);